module.exports = __webpack_public_path__ + "img/azure.f34207f3.png";